export default __webpack_public_path__ + "static/media/teste.eb164115.gif";